import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  REGISTER_CREDIT_CARD_FEATURE_KEY,
  RegisterCreditCardState,
} from './register-credit-card.reducer';

// Lookup the 'RegisterCreditCard' feature state managed by NgRx
export const getRegisterCreditCardState =
  createFeatureSelector<RegisterCreditCardState>(
    REGISTER_CREDIT_CARD_FEATURE_KEY,
  );

export const isVerifyingCreditCard = createSelector(
  getRegisterCreditCardState,
  (state: RegisterCreditCardState) => state.verifying,
);

export const isVerifiedCreditCard = createSelector(
  getRegisterCreditCardState,
  (state: RegisterCreditCardState) => state.verified,
);

export const getRegisterCreditCardError = createSelector(
  getRegisterCreditCardState,
  (state: RegisterCreditCardState) => state.error,
);
